export default "__VITE_ASSET__Vzv91$Og__"